import { getRememberMe, setRememberMe } from './persistence.js';
/** App route that accepts a portal handoff hash and seeds the local Supabase session. */
export const AUTH_BRIDGE_PATH = '/auth/bridge';
/** Portal and app are different origins; sessions are bridged on "Enter the app". */
export const ACTIVE_CROSS_ORIGIN_STRATEGY = 'hash-bridge';
export function buildCrossOriginHandoffUrl(appBaseUrl, session, options) {
    const base = appBaseUrl.replace(/\/$/, '');
    const remember = options?.rememberMe !== undefined ? (options.rememberMe ? '1' : '0') : undefined;
    const query = remember !== undefined ? `?remember=${remember}` : '';
    const hash = new URLSearchParams({
        access_token: session.access_token,
        refresh_token: session.refresh_token,
        expires_in: String(session.expires_in ?? 3600),
        token_type: 'bearer',
        type: 'magiclink',
    });
    return `${base}${AUTH_BRIDGE_PATH}${query}#${hash.toString()}`;
}
/** Navigate from portal (or any origin) to the app, carrying the current Supabase session. */
export async function navigateToAppWithSession(supabase, appBaseUrl) {
    const { data: { session }, } = await supabase.auth.getSession();
    const base = appBaseUrl.replace(/\/$/, '');
    if (!session) {
        window.location.href = base;
        return;
    }
    window.location.href = buildCrossOriginHandoffUrl(appBaseUrl, session, {
        rememberMe: getRememberMe(),
    });
}
export function parseHandoffFromLocation(location) {
    const raw = location.hash.replace(/^#/, '');
    if (!raw)
        return null;
    const params = new URLSearchParams(raw);
    const accessToken = params.get('access_token');
    const refreshToken = params.get('refresh_token');
    if (!accessToken || !refreshToken)
        return null;
    return { accessToken, refreshToken };
}
export function parseRememberMeFromSearch(search) {
    const value = new URLSearchParams(search).get('remember');
    if (value === '1')
        return true;
    if (value === '0')
        return false;
    return undefined;
}
/** Consume portal handoff on the app origin and persist the session locally. */
export async function applyCrossOriginHandoff(supabase, location) {
    const tokens = parseHandoffFromLocation(location);
    if (!tokens) {
        return { ok: false, reason: 'Missing session in handoff URL' };
    }
    const remember = parseRememberMeFromSearch(location.search);
    if (remember !== undefined) {
        setRememberMe(remember);
    }
    const { error } = await supabase.auth.setSession({
        access_token: tokens.accessToken,
        refresh_token: tokens.refreshToken,
    });
    if (error) {
        return { ok: false, reason: error.message };
    }
    return { ok: true };
}
//# sourceMappingURL=cross-origin.js.map